import React from 'react';
import _ from 'lodash';

import DDadosBase, { LabeledInput } from '@common/components/ddados/ddados.base';

import Field from '@common/components/validation/field.validation';
import { OverlayTrigger, Tooltip as TooltipBootstrap } from 'react-bootstrap';

import FocusHelper from '@common/helpers/focus.helper';


class DDadosComponent extends DDadosBase {
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    this.setFocus();
  }

  setFocus() {
    const { name, setFocus } = this.props;
    if (setFocus) FocusHelper.focus(name);
  }

  renderComponent() {
    const { props, validate } = this;
    const {
      Label,
      Tooltip,
      Obrigatorio,
      Desabilitado,
      Placeholder,
      Tamanho,
      TamanhoMinimo,
      Linhas,
      name,
      PlacementTooltip,
      showCount,
      inputRef
    } = props;

    return (
      <Field {...props} validate={validate}>
        {({ value, hasError, onChangeAsync, onBlur }) => {
          return (
            <LabeledInput {...props}>
              <OverlayTrigger
                key={`top-${name}`}
                placement={PlacementTooltip || 'top'}
                overlay={
                  <TooltipBootstrap id={`tooltip-${name}`}>
                    <div className={'fontTooltip'}>{Tooltip || Label}</div>
                  </TooltipBootstrap>
                }
              >
                <div>
                  <textarea
                    className={`form-control ${hasError ? 'form-invalid' : ''}`}
                    name={name}
                    value={value || ''}
                    readOnly={Desabilitado}
                    required={Obrigatorio}
                    onChange={onChangeAsync}
                    onBlur={onBlur}
                    maxLength={Tamanho || 200}
                    minLength={TamanhoMinimo}
                    placeholder={Placeholder || Label}
                    rows={Linhas || 3}
                    ref={inputRef}
                  />
                  {showCount && (
                    <label className="float-right">
                      {(value || '').length}/{Tamanho || 200}
                    </label>
                  )}
                </div>
              </OverlayTrigger>
            </LabeledInput>
          );
        }}
      </Field>
    );
  }

  renderView() {
    return (
      <Field {...this.props}>
        {(field) => {
          return (
            <LabeledInput {...this.props} Obrigatorio={false}>
              <span>
                <textarea
                  className="form-control is-view textarea-isview"
                  value={field.value || ''}
                  readOnly={true}
                  rows={this.props.Linhas || 3}
                />
              </span>
            </LabeledInput>
          );
        }}
      </Field>
    );
  }

  renderHeader() {
    return (
      <div>
        <Field {...this.props}>
          {(field) => {
            return (
              <label style={{ fontWeight: 'bold' }}>
                {this.props.Label}
                <label>{field.value || ''}</label>
              </label>
            );
          }}
        </Field>
      </div>
    );
  }
}

DDadosComponent.defaultProps = {
  showCount: true,
};

export default DDadosComponent;
